// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caseDetails__wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 50%;
}
.notesWrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 50%;
  background: #fff;
}
.notesSection_openNotes {
  background: #e0a633;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 5px 20px 5px 20px;
  vertical-align: middle;
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: 100px;
  z-index: 1;
  position: fixed;
}
.notesSection_openNotesIcon {
  margin-right: 8px;
}
.notesSection_openNotesIcon,
.notesSection_openNotesText {
  display: inline-block;
  vertical-align: middle;
}
.notesSection {
  background: #fff;
  position: absolute;
  width: calc(100% - 15px);
  height: 100%;
  right: -100%;
  padding-top: 50px;
  transition: all 0.5s;
  -ms-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.notesSection.openNotesSection {
  right: 4px;
  z-index: 2;
}
.notesSection__header {
  position: absolute;
  background: #e6ebf0;
  padding: 10px 40px;
  left: 0;
  top: 0;
  width: 100%;
}
.notesSection__header .notesSection_closeIcon {
  position: absolute;
  top: 0;
  left: -11px;
  cursor: pointer;
}
.notesSection__headerHeading {
  font-size: 18px;
  color: #000;
  font-weight: 600;
  line-height: 1.4;
}
.notesSection__headerLabel {
  font-size: 12px;
  color: #000;
}
.notesSection__notes {
  padding: 20px;
}
.notesSection__notes:nth-child(even) {
  background: #f5f5f5;
}
.notesSection__timeDeleteWrapper {
  align-items: flex-start;
}
.notesSection__notesTime {
  color: #e0a633;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 10px;
  font-weight: 600;
  padding-right: 10px;
  width: calc(100% - 20px);
}
.notesSection__content {
  overflow-y: scroll;
  height: 100%;
  padding-bottom: 180px;
  min-width:350px;
}
.notesSection__content::-webkit-scrollbar {
  width: 8px;
}
/* Track */
.notesSection__content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.notesSection__content::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.notesSection__content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.notesSection__text {
  color: #333333;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}
.notesSection__deleteNote {
  width: 20px;
  background: none;
  border: none;
  padding: 0;
  position: relative;
  top: -4px;
  cursor: pointer;
}
.notesSection__deleteNote > img {
  width: 100%;
}
.addNotes__form {
  padding: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  width: 100%;
}
.addNotes_textarea {
  height: 100px;
  width: 100%;
  border: 1px solid #d6d6d6;
  padding: 10px;
  margin-bottom: 10px;
  color: #1984bc;
  outline: none;
  border-radius: 5px;
}
.addNotes_textarea:focus {
  border: 1px solid #222;
}
.addNotes__action {
  text-align: right;
}
.addNotes__action .button:disabled {
  background: #1984bc;
}
.notesSection__empty {
  font-size: 14px;
  padding: 15px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/notesSection/NotesSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".caseDetails__wrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 50%;\n}\n.notesWrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 50%;\n  background: #fff;\n}\n.notesSection_openNotes {\n  background: #e0a633;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-block;\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n  padding: 5px 20px 5px 20px;\n  vertical-align: middle;\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  bottom: 100px;\n  z-index: 1;\n  position: fixed;\n}\n.notesSection_openNotesIcon {\n  margin-right: 8px;\n}\n.notesSection_openNotesIcon,\n.notesSection_openNotesText {\n  display: inline-block;\n  vertical-align: middle;\n}\n.notesSection {\n  background: #fff;\n  position: absolute;\n  width: calc(100% - 15px);\n  height: 100%;\n  right: -100%;\n  padding-top: 50px;\n  transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n}\n\n.notesSection.openNotesSection {\n  right: 4px;\n  z-index: 2;\n}\n.notesSection__header {\n  position: absolute;\n  background: #e6ebf0;\n  padding: 10px 40px;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n.notesSection__header .notesSection_closeIcon {\n  position: absolute;\n  top: 0;\n  left: -11px;\n  cursor: pointer;\n}\n.notesSection__headerHeading {\n  font-size: 18px;\n  color: #000;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.notesSection__headerLabel {\n  font-size: 12px;\n  color: #000;\n}\n.notesSection__notes {\n  padding: 20px;\n}\n.notesSection__notes:nth-child(even) {\n  background: #f5f5f5;\n}\n.notesSection__timeDeleteWrapper {\n  align-items: flex-start;\n}\n.notesSection__notesTime {\n  color: #e0a633;\n  font-size: 14px;\n  line-height: 1.2;\n  margin-bottom: 10px;\n  font-weight: 600;\n  padding-right: 10px;\n  width: calc(100% - 20px);\n}\n.notesSection__content {\n  overflow-y: scroll;\n  height: 100%;\n  padding-bottom: 180px;\n  min-width:350px;\n}\n.notesSection__content::-webkit-scrollbar {\n  width: 8px;\n}\n/* Track */\n.notesSection__content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.notesSection__content::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n/* Handle on hover */\n.notesSection__content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.notesSection__text {\n  color: #333333;\n  font-size: 12px;\n  margin-bottom: 5px;\n  line-height: 1.5;\n}\n.notesSection__deleteNote {\n  width: 20px;\n  background: none;\n  border: none;\n  padding: 0;\n  position: relative;\n  top: -4px;\n  cursor: pointer;\n}\n.notesSection__deleteNote > img {\n  width: 100%;\n}\n.addNotes__form {\n  padding: 20px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  width: 100%;\n}\n.addNotes_textarea {\n  height: 100px;\n  width: 100%;\n  border: 1px solid #d6d6d6;\n  padding: 10px;\n  margin-bottom: 10px;\n  color: #1984bc;\n  outline: none;\n  border-radius: 5px;\n}\n.addNotes_textarea:focus {\n  border: 1px solid #222;\n}\n.addNotes__action {\n  text-align: right;\n}\n.addNotes__action .button:disabled {\n  background: #1984bc;\n}\n.notesSection__empty {\n  font-size: 14px;\n  padding: 15px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
